import * as Account from './components/Account/Account.css';
import * as Lang from './components/Lang/Lang.css';
import * as SocialAuth from './components/SocialAuth/SocialAuth.css';
const theme = {
    Account: {
        Account: {
            social__networks: Account.socialButtons,
            account__offers: Account.offers
        }
    },
    Lang: {
        LangStyles: {
            lang__selected: Lang.selected,
            dropdown__icon: Lang.icon,
            dropdown: Lang.dropdown,
            lang_opened: Lang.lang_opened
        }
    },
    Sidebar: {
        MobileMenu: {
            user: Account.user
        },
        Sidebar: {
            sidebar: Account.sidebar
        }
    },
    SocialAuth: {
        SocialAuth: {
            wrapper: SocialAuth.wrapper
        }
    },
    TravellerForm: {
        DocumentFieldsItem: {
            documentFieldsItem: Account.documentFieldsItem
        }
    }
};
export default theme;
